// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VFileUpload } from 'vuetify/labs/VFileUpload'

// Vuetify
import { createVuetify } from 'vuetify'

const myCustomLightTheme = {
  
  "dark": false,
  "colors": {
    "background": "#FDFDFD",
    "surface": "#FFFFFF",
    "primary": "#E4ECE2",
    "secondary": "#DAE5E2",
    "error": "#F44336",
    "info": "#0F83DF",
    "success": "#4CAF50",
    "warning": "#FFC107",
    "on-background": "#212121",
    "on-surface": "#212121"
  }
}

const myCustomDarkTheme = {
  "dark": true,
  "colors": {
    "background": "#121212",
    "surface": "#212121",
    "primary": "#BB86FC",
    "secondary": "#03DAC5",
    "error": "#CF6679",
    "info": "#2196F3",
    "success": "#4CAF50",
    "warning": "#FB8C00",
    "on-background": "#fff",
    "on-surface": "#fff"
  }
};

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  components: {
    VFileUpload,
  },
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
      myCustomDarkTheme,
    },
  },
});
